module.exports = __webpack_public_path__ + "img/banner1.75a54c6e.jpg";